/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _components = require('components');

/* eslint id-length: 0 */

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var RecentComments = (function (_Component) {
	_inherits(RecentComments, _Component);

	function RecentComments() {
		_classCallCheck(this, _RecentComments);

		_Component.apply(this, arguments);
	}

	RecentComments.prototype.render = function render() {
		var _classNames;

		var styles = require('./RecentComments.css');

		var baseClassNames = _classnames2['default']((_classNames = {}, _classNames[styles.Base] = true, _classNames[this.props.className] = this.props.className, _classNames));

		/* Map comments from API to <article/> elements */
		var articleRoll = _lodash2['default'].map(this.props.comments, function (article, index) {
			return _react2['default'].createElement(
				'article',
				{ className: styles.Article, key: index },
				_react2['default'].createElement(
					_reactRouter.Link,
					{ className: styles.Link, to: article.post.url },
					_react2['default'].createElement(
						'h4',
						{ className: styles.Username },
						article.author,
						':'
					),
					_react2['default'].createElement(
						'p',
						{ className: styles.Content },
						article.content
					),
					_react2['default'].createElement(
						'footer',
						{ className: styles.CommentCount },
						_react2['default'].createElement(_components.CommentCount, { count: article.post.comment_count, className: styles.Icon }),
						_react2['default'].createElement(
							'h2',
							{ className: styles.Title },
							article.post.title
						)
					)
				)
			);
		});

		return _react2['default'].createElement(
			'section',
			{ className: baseClassNames },
			_react2['default'].createElement(_components.HeaderTab, { icon: 'talk-bubble', title: 'Recent Comments' }),
			_react2['default'].createElement(
				'div',
				{ className: styles.Articles },
				articleRoll
			)
		);
	};

	_createClass(RecentComments, null, [{
		key: 'propTypes',
		value: {
			comments: _react.PropTypes.array,
			className: _react.PropTypes.string
		},
		enumerable: true
	}]);

	var _RecentComments = RecentComments;
	RecentComments = _reactRedux.connect(function (state) {
		return {
			comments: state.recentComments.data
		};
	})(RecentComments) || RecentComments;
	return RecentComments;
})(_react.Component);

exports['default'] = RecentComments;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/RecentComments/RecentComments.js
 ** module id = 688
 ** module chunks = 0
 **/